export const enableLogRocket = () => {};

export const assignUserIdToLogger = id => {};
